import { ArrowDown as ArrowDown_kojaro } from './ArrowDown.kojaro';
import { ArrowDown as ArrowDown_phosphor } from './ArrowDown.phosphor';
import { ArrowDown as ArrowDown_zoomg } from './ArrowDown.zoomg';
import { ArrowDown as ArrowDown_zoomit } from './ArrowDown.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return ArrowDown_kojaro;

    case 'zoomg':
      return ArrowDown_zoomg;

    case 'phosphor':
      return ArrowDown_phosphor;

    default:
      return ArrowDown_zoomit;
  }
};

export const ArrowDown = IconRenderer();
